/*
  Copyright (c) Epic Games, Inc. All Rights Reserved.
  CONTAINS AI GENERATED CODE. 
*/

import { Metadata } from "next";

import { ErrorTestPage } from "./ErrorTestPage.client";

export const metadata: Metadata = {
	title: "Error Test Page",
	robots: {
		index: false,
		follow: false,
	},
};

export default function CosmosErrorTestPage(): React.JSX.Element {
	return <ErrorTestPage />;
}
